import { useLocation, useNavigate } from 'react-router';
import { useRoute } from 'src/router/hooks/useRoute';
import { isLanguageSupported } from '../utils/isLanguageSupported';
import { changeLanguageInPathname } from '../utils/changeLanguageInPathname';
import { LS_DEBUG_LANGUAGE_KEY } from '../config';

const isDebugMode = localStorage.getItem(LS_DEBUG_LANGUAGE_KEY);

/** Этот хук возвращает функцию, которая может выполнить навигейт на тот же URL,
 * и подставить/заменить код языка на тот который в нее передан. Используется для
 * подстановки кода языка в URL при смене языка в селекторе
 *
 * Пример использования:
 *   const setLanguageToUrl = useSetLanguageToUrl();
 *    setLanguageToUrl('de')
 *   */

export const useSetLanguageToUrl = () => {
  const { state, pathname, search } = useLocation();
  const navigate = useNavigate();
  const { ROUTE } = useRoute();

  return (language?: string) => {
    if (!language) return;
    if (!isLanguageSupported(language)) return;
    if (isDebugMode) {
      console.debug('записали язык в localstorage');
    }
    let path = changeLanguageInPathname(pathname, language);

    if (path === pathname) return;

    if (path !== ROUTE.MAIN.path) {
      path = path.replace(/\/$/, '');
    }

    navigate(path + search, {
      state: state,
      replace: true
    });
  };
};
